// src/pages/ConnectionPageFake.js
import React from 'react';
import { Link } from 'react-router-dom';
import './ConnectionPageFake.css'; // Import our custom styles

const ConnectionPageFake = () => {
  // Hardcoded sample data
  const cardData = {
    name: 'Asray Gopa',
    title: 'Student at Iowa State University',
    location: 'Ames, IA',
    profile_pic: 'https://via.placeholder.com/150?text=Profile+Pic',
    call: '+1234567890',
    email: 'asray@example.com',
    text: '+1234567890',
    social_links: {
      github: 'https://github.com/AsrayGopa',
      linkedin: 'https://linkedin.com/in/AsrayGopa',
      website: 'https://the-brik.com',
      websiteIcon: 'globe'
    },
    about: `Computer Science and Entrepreneurship Sophomore at Iowa State. 
    Developing Medical Insurance Software for WellGuard LLC. Creating
    mobile solutions for those who forget at The Brik. Developer for 
    Student Government. Also leading strategy code for the Iowa State 
    University Solar Car Team (prISUm). Skilled at Python, Java, 
    Application Development, Public Speaking, Leadership, and Communication.`,
    highlights: [
      {
        heading: '1st Place At Iowa State Innovation Prize',
        image_url: 'https://via.placeholder.com/300x200?text=Innovation+Prize',
        description: ''
      }
    ]
  };

  const copyLinkToClipboard = () => {
    navigator.clipboard.writeText(window.location.href);
    alert('Link copied to clipboard!');
  };

  return (
    <div className="connection-page-container">
      <div className="card-wrapper">
        {/* Profile Section */}
        <div className="profile-section">
          <img 
            className="profile-pic"
            src={cardData.profile_pic} 
            alt={`${cardData.name} profile`} 
          />
          <div className="profile-info">
            <h1 className="profile-name">{cardData.name}</h1>
            <p className="profile-title">{cardData.title}</p>
            <p className="profile-location">{cardData.location}</p>
          </div>
          <button className="share-btn" onClick={copyLinkToClipboard}>
            Share Link
          </button>
        </div>

        {/* Social / Website Links */}
        <div className="social-links-section">
          {cardData.social_links.github && (
            <a
              href={cardData.social_links.github}
              target="_blank"
              rel="noopener noreferrer"
              className="social-link-item"
            >
              <i className="fab fa-github"></i>
              <span>{`${cardData.name.split(' ')[0]}'s GitHub`}</span>
            </a>
          )}
          {cardData.social_links.linkedin && (
            <a
              href={cardData.social_links.linkedin}
              target="_blank"
              rel="noopener noreferrer"
              className="social-link-item"
            >
              <i className="fab fa-linkedin"></i>
              <span>{`${cardData.name.split(' ')[0]}'s LinkedIn`}</span>
            </a>
          )}
          {cardData.social_links.website && (
            <a
              href={cardData.social_links.website}
              target="_blank"
              rel="noopener noreferrer"
              className="social-link-item"
            >
              <i
                className={
                  cardData.social_links.websiteIcon
                    ? `fa fa-${cardData.social_links.websiteIcon}`
                    : 'fa fa-globe'
                }
              ></i>
              <span>Personal Website</span>
            </a>
          )}
        </div>

        {/* About Section */}
        <div className="about-section">
          <h2>About {cardData.name.split(' ')[0]}</h2>
          <p>{cardData.about}</p>
        </div>

        {/* Contact Buttons */}
        <div className="contact-section">
          {cardData.call && (
            <a href={`tel:${cardData.call}`} className="contact-btn">
              <i className="fa fa-phone"></i>
              <span>Call</span>
            </a>
          )}
          {cardData.text && (
            <a href={`sms:${cardData.text}`} className="contact-btn">
              <i className="fa fa-comment"></i>
              <span>Text</span>
            </a>
          )}
          {cardData.email && (
            <a href={`mailto:${cardData.email}`} className="contact-btn">
              <i className="fa fa-envelope"></i>
              <span>Email</span>
            </a>
          )}
        </div>

        {/* Highlights / Gallery Section */}
        <div className="highlights-section">
          {cardData.highlights.map((item, index) => (
            <div key={index} className="highlight-item">
              <h3>{item.heading}</h3>
              <img
                className="highlight-image"
                src={item.image_url}
                alt={item.heading}
              />
              {item.description && <p>{item.description}</p>}
            </div>
          ))}
        </div>

        <div className="edit-link">
          <Link to="/edit-connection">Edit Connection</Link>
        </div>
      </div>
    </div>
  );
};

export default ConnectionPageFake;
